import { VideoModelData, VideoModelResponse } from '../interface/VideoModels.ts';

class GetVideoModelsResponse {
	models: Record<string, VideoModelData>;

	defaultModel: string;

	constructor(responseData: VideoModelResponse) {
		this.models = responseData?.models ?? {};
		this.defaultModel = responseData?.default_model ?? '';
	}

	formatVideoModelsData() {
		if (!this.models || typeof this.models !== 'object')
			return { defaultModel: this.defaultModel, modelsData: [] };
		const modelsData = Object.entries(this.models).map(([modelName, modelData]) => ({
			id: modelName,
			name: modelName,
			active: modelData.active,
			provider: modelData.provider,
			cost: modelData.credits_per_generation,
			maxPromptLength: modelData.max_prompt_length,
			minPromptLength: modelData.min_prompt_length,
			outputDuration: modelData.output_duration,
			displayOrder: modelData.display_order,
		}));

		return { defaultModel: this.defaultModel, modelsData };
	}
}

export default GetVideoModelsResponse;
